import { registerSvNumeralLocales } from "./sv.es8";

export const registerNumeralLocales = () => {
    registerSvNumeralLocales();
    numeral.localeData().delimiters.thousands = ' ';
  }